import { getLabel, dayjs } from '@weapp/utils'

export const getLang = () => ((window.TEAMS?.locale?.lang) || document.cookie.match(/langType=(.*?)(;|$)/)?.[1] || window.navigator.language || 'zh-CN').replace(/-/g, () => '_');

export const showLunar = (getLang() === 'zh_CN' || getLang() === 'zh_TW')

// 常量
const lunarInfo = [
  0x04bd8,
  0x04ae0,
  0x0a570,
  0x054d5,
  0x0d260,
  0x0d950,
  0x16554,
  0x056a0,
  0x09ad0,
  0x055d2,
  0x04ae0,
  0x0a5b6,
  0x0a4d0,
  0x0d250,
  0x1d255,
  0x0b540,
  0x0d6a0,
  0x0ada2,
  0x095b0,
  0x14977,
  0x04970,
  0x0a4b0,
  0x0b4b5,
  0x06a50,
  0x06d40,
  0x1ab54,
  0x02b60,
  0x09570,
  0x052f2,
  0x04970,
  0x06566,
  0x0d4a0,
  0x0ea50,
  0x06e95,
  0x05ad0,
  0x02b60,
  0x186e3,
  0x092e0,
  0x1c8d7,
  0x0c950,
  0x0d4a0,
  0x1d8a6,
  0x0b550,
  0x056a0,
  0x1a5b4,
  0x025d0,
  0x092d0,
  0x0d2b2,
  0x0a950,
  0x0b557,
  0x06ca0,
  0x0b550,
  0x15355,
  0x04da0,
  0x0a5d0,
  0x14573,
  0x052d0,
  0x0a9a8,
  0x0e950,
  0x06aa0,
  0x0aea6,
  0x0ab50,
  0x04b60,
  0x0aae4,
  0x0a570,
  0x05260,
  0x0f263,
  0x0d950,
  0x05b57,
  0x056a0,
  0x096d0,
  0x04dd5,
  0x04ad0,
  0x0a4d0,
  0x0d4d4,
  0x0d250,
  0x0d558,
  0x0b540,
  0x0b5a0,
  0x195a6,
  0x095b0,
  0x049b0,
  0x0a974,
  0x0a4b0,
  0x0b27a,
  0x06a50,
  0x06d40,
  0x0af46,
  0x0ab60,
  0x09570,
  0x04af5,
  0x04970,
  0x064b0,
  0x074a3,
  0x0ea50,
  0x06b58,
  0x055c0,
  0x0ab60,
  0x096d5,
  0x092e0,
  0x0c960,
  0x0d954,
  0x0d4a0,
  0x0da50,
  0x07552,
  0x056a0,
  0x0abb7,
  0x025d0,
  0x092d0,
  0x0cab5,
  0x0a950,
  0x0b4a0,
  0x0baa4,
  0x0ad50,
  0x055d9,
  0x04ba0,
  0x0a5b0,
  0x15176,
  0x052b0,
  0x0a930,
  0x07954,
  0x06aa0,
  0x0ad50,
  0x05b52,
  0x04b60,
  0x0a6e6,
  0x0a4e0,
  0x0d260,
  0x0ea65,
  0x0d530,
  0x05aa0,
  0x076a3,
  0x096d0,
  0x04bd7,
  0x04ad0,
  0x0a4d0,
  0x1d0b6,
  0x0d250,
  0x0d520,
  0x0dd45,
  0x0b5a0,
  0x056d0,
  0x055b2,
  0x049b0,
  0x0a577,
  0x0a4b0,
  0x0aa50,
  0x1b255,
  0x06d20,
  0x0ada0,
];
const solarMonth = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
//生肖年
const animals = ['猴', '鸡', '狗', '猪', '鼠', '牛', '虎', '兔', '龙', '蛇', '马', '羊'];
//天干
const zodiac_sky = ['癸', '甲', '乙', '丙', '丁', '戊', '己', '庚', '辛', '壬'];
//地支
const zodiac_land = ['亥', '子', '丑', '寅', '卯', '辰', '巳', '午', '未', '申', '酉', '戌'];
//农历月份
const nMonth = ["正", "二", "三", "四", "五", "六", "七", "八", "九", "十", "冬", "腊"]
//农历日
const nStr1 = ['日', '一', '二', '三', '四', '五', '六', '七', '八', '九', '十']
const nStr2 = ['初', '十', '廿', '卅'];
const sTermInfo = [
  0,
  21208,
  42467,
  63836,
  85337,
  107014,
  128867,
  150921,
  173149,
  195551,
  218072,
  240693,
  263343,
  285989,
  308563,
  331033,
  353350,
  375494,
  397447,
  419210,
  440795,
  462224,
  483532,
  504758,
];
//2023-02-03 多语言标签需要放到function中返回，做为常量可能会导致getLabel方法失效
//农历节气
const getSolarTerm = () => [
  getLabel('92970', '小寒'),
  getLabel('92971', '大寒'),
  getLabel('92975', '立春'),
  getLabel('92976', '雨水'),
  getLabel('92978', '惊蛰'),
  getLabel('92979', '春分'),
  getLabel('92980', '清明'),
  getLabel('92981', '谷雨'),
  getLabel('92982', '立夏'),
  getLabel('92983', '小满'),
  getLabel('92984', '芒种'),
  getLabel('92985', '夏至'),
  getLabel('92986', '小暑'),
  getLabel('92987', '大暑'),
  getLabel('92989', '立秋'),
  getLabel('92990', '处暑'),
  getLabel('92991', '白露'),
  getLabel('92992', '秋分'),
  getLabel('92993', '寒露'),
  getLabel('92994', '霜降'),
  getLabel('92995', '立冬'),
  getLabel('92996', '小雪'),
  getLabel('92997', '大雪'),
  getLabel('92998', '冬至'),
]
// 公历节日
const getSFtv = () => [
  // '0101 元旦',
  `0101 ${getLabel('91882', '元旦')}`,
  // '0214 情人节',
  `0214 ${getLabel('91883', '情人节')}`,
  // '0308 妇女节',
  `0308 ${getLabel('91884', '妇女节')}`,
  // '0312 植树节',
  `0312 ${getLabel('91885', '植树节')}`,
  // '0315 消费者权益日',
  `0315 ${getLabel('91886', '消费者权益日')}`,
  // '0401 愚人节',
  `0401 ${getLabel('91888', '愚人节')}`,
  // '0501 劳动节',
  `0501 ${getLabel('91890', '劳动节')}`,
  // '0504 青年节',
  `0504 ${getLabel('91891', '青年节')}`,
  // '0512 护士节',
  `0512 ${getLabel('91892', '护士节')}`,
  // '0601 儿童节',
  `0601 ${getLabel('91893', '儿童节')}`,
  // '0701 建党节',
  `0701 ${getLabel('91894', '建党节')}`,
  // '0801 建军节',
  `0801 ${getLabel('91895', '建军节')}`,
  // '0910 教师节',
  `0910 ${getLabel('91896', '教师节')}`,
  // '0928 孔子诞辰',
  `0928 ${getLabel('91897', '孔子诞辰')}`,
  // '1001 国庆节',
  `1001 ${getLabel('91899', '国庆节')}`,
  // '1024 联合国日',
  `1024 ${getLabel('91900', '联合国日')}`,
  // '1224 平安夜',
  `1224 ${getLabel('91901', '平安夜')}`,
  // '1225 圣诞节',
  `1225 ${getLabel('91902', '圣诞节')}`
]
// 农历节日
const getLFtv = () => [
  // '0101 春节',
  `0101 ${getLabel('91904', '春节')}`,
  // '0115 元宵节',
  `0115 ${getLabel('91905', '元宵节')}`,
  // '0505 端午节',
  `0505 ${getLabel('91906', '端午节')}`,
  // '0707 七夕',
  `0707 ${getLabel('91907', '七夕')}`,
  // '0715 中元节',
  `0715 ${getLabel('91908', '中元节')}`,
  // '0815 中秋节',
  `0815 ${getLabel('91909', '中秋节')}`,
  // '0909 重阳节',
  `0909 ${getLabel('91910', '重阳节')}`,
  // '1208 腊八节',
  `1208 ${getLabel('91913', '腊八节')}`,
  // '1224 小年',
  `1224 ${getLabel('91914', '小年')}`
]

// 判断y年的农历中那个月是闰月,不是闰月返回0
function leapMonth(y: number) {
  // tslint:disable-next-line: no-bitwise
  return lunarInfo[y - 1900] & 0xf;
}
// 返回农历y年闰月的天数
function leapDays(y: number) {
  if (leapMonth(y)) {
    // tslint:disable-next-line: no-bitwise
    return lunarInfo[y - 1900] & 0x10000 ? 30 : 29;
  }
  return 0;
}
// 返回农历y年的总天数
function lYearDays(y: number) {
  let sum = 348;
  // tslint:disable-next-line: no-bitwise
  for (let i = 0x8000; i > 0x8; i >>= 1) {
    // tslint:disable-next-line: no-bitwise
    sum += lunarInfo[y - 1900] & i ? 1 : 0;
  }
  return sum + leapDays(y);
}
// 返回农历y年m月的总天数
function monthDays(y: number, m: number) {
  // tslint:disable-next-line: no-bitwise
  return lunarInfo[y - 1900] & (0x10000 >> m) ? 30 : 29;
}
// 返回公历y年m+1月的天数
function solarDays(y: number, m: number) {
  if (m === 1) {
    // tslint:disable-next-line: no-bitwise
    return (y % 4 === 0 && y % 100 !== 0) || y % 400 === 0 ? 29 : 28;
  }
  return solarMonth[m];
}

// 返回某年的第n个节气为几日(从0小寒起算)
function sTerm(y: number, n: number) {
  const offDate = new Date(
    31556925974.7 * (y - 1900) +
    sTermInfo[n] * 60000 +
    Date.UTC(1900, 0, 6, 2, 5),
  );
  return offDate.getUTCDate();
}
// 修复部分节气错误
function sTermFix(y: number, m: number) {
  let tmp1 = sTerm(y, m * 2) - 1;
  let tmp2 = sTerm(y, m * 2 + 1) - 1;
  const y1 = y % 100;
  const ly1 = Math.floor(y1 / 4);
  const base = y1 * 0.2422;
  switch (m) {
    case 1:
      tmp2 = parseInt(String(base + 18.73), 10) - ly1 - 1; // 雨水
      if (y === 2026) { tmp2 += 1; }
      break;
    case 5:
      tmp2 = parseInt(String(base + 21.37), 10) - ly1 - 1; // 夏至
      if (y === 1928) { tmp2 += 1; }
      break;
    case 6:
      tmp1 = parseInt(String(base + 7.108), 10) - ly1 - 1; // 小暑
      if (y === 1925 || y === 2016) { tmp1 += 1; }
      tmp2 = parseInt(String(base + 22.83), 10) - ly1 - 1; // 大暑
      if (y === 1922) { tmp2 += 1; }
      break;
    case 7:
      tmp2 = parseInt(String(base + 23.13), 10) - ly1 - 1; // 处暑
      break;
    case 8:
      tmp1 = parseInt(String(base + 7.646), 10) - ly1 - 1; // 白露
      if (y === 1927) { tmp1 += 1; }
      break;
    case 9:
      tmp2 = parseInt(String(base + 23.438), 10) - ly1 - 1; // 霜降
      if (y === 2089) { tmp2 += 1; }
      break;
    case 10:
      tmp1 = parseInt(String(base + 7.438), 10) - ly1 - 1; // 立冬
      if (y === 2089) { tmp1 += 1; }
      tmp2 = parseInt(String(base + 22.36), 10) - ly1 - 1; // 小雪
      break;
    case 11:
      tmp1 = parseInt(String(base + 7.18), 10) - ly1 - 1; // 大雪
      if (y === 1954) { tmp1 += 1; }
      tmp2 = parseInt(String(base + 21.94), 10) - ly1 - 1; // 冬至
      if (y === 1918 || y === 2021) { tmp2 -= 1; }
      break;
    default:
      break;
  }
  return { tmp1, tmp2 };
}
// 用中文显示农历的日期
function cDay(d: number) {
  let s;
  switch (d) {
    case 10:
      s = '初十';
      break;
    case 20:
      s = '二十';
      break;
    case 30:
      s = '三十';
      break;
    default:
      s = nStr2[Math.floor(d / 10)];
      s += nStr1[parseInt(String(d % 10), 10)];
      break;
  }
  return s;
}

// 算出当前月第一天的农历日期和当前农历日期下一个月农历的第一天日期
export class Dianaday {
  isLeap: boolean;
  year: number;
  month: number;
  day: number;
  yearCyl: number;
  monCyl: number;
  dayCyl: number;
  constructor(objDate: Date) {
    let i;
    let leap = 0;
    let temp = 0;
    // const baseDate  = dayjs('1900-01-31').tz('Asia/Shanghai')
    const baseDate = new Date(1900, 0, 31);
    // let offset = parseInt(String((objDate.getTime() - baseDate.getTime()) / (24 * 60 * 60 * 1000)), 10);
    // const b = dayjs().set('year',1900).set('month', dayjs().month() + 1).set('date', 0).set('hour',0).set('minute',0).set('second',0)
    // const baseDate = new Date(b.format())
    // let offset = parseInt(String((objDate.getTime() - baseDate.getTime()) / (24 * 60 * 60 * 1000)), 10);
    let offset = dayjs(objDate).diff(baseDate, 'day')
    this.dayCyl = offset + 40;
    this.monCyl = 14;
    for (i = 1900; i < 2050 && offset > 0; i += 1) {
      temp = lYearDays(i);
      offset -= temp;
      this.monCyl += 12;
    }
    if (offset < 0) {
      offset += temp;
      i -= 1;
      this.monCyl -= 12;
    }
    this.year = i;
    this.yearCyl = i - 1864;
    leap = leapMonth(i); // 闰哪个月
    this.isLeap = false;
    for (i = 1; i < 13 && offset > 0; i += 1) {
      if (leap > 0 && i === leap + 1 && this.isLeap === false) {
        // 闰月
        i -= 1;
        this.isLeap = true;
        temp = leapDays(this.year);
      } else {
        temp = monthDays(this.year, i);
      }
      if (this.isLeap === true && i === leap + 1) {
        this.isLeap = false; // 解除闰月
      }
      offset -= temp;
      if (this.isLeap === false) {
        this.monCyl += 1;
      }
    }
    if (offset === 0 && leap > 0 && i === leap + 1) {
      if (this.isLeap) {
        this.isLeap = false;
      } else {
        this.isLeap = true;
        i -= 1;
        this.monCyl -= 1;
      }
    }
    if (offset < 0) {
      offset += temp;
      i -= 1;
      this.monCyl -= 1;
    }
    this.month = i;
    this.day = offset + 1;
  }
}

// 记录公历和农历某天的日期
export class CalElement {
  isLeap: boolean;
  isToday: boolean;
  sYear: number;
  sMonth: number;
  sDay: number;
  week: string;
  lYear: number;
  lMonth: number;
  lDay: number;
  lunarFestival: string;
  solarFestival: string;
  solarTerms: string;
  sDisplay: string;
  lDisplay: string;
  lDisplayArr: string[];
  constructor(sYear: number, sMonth: number, sDay: number, week: string, lYear: number, lMonth: number, lDay: number, isLeap: boolean) {
    this.isToday = false;
    // 公历
    this.sYear = sYear;
    this.sMonth = sMonth;
    this.sDay = sDay;
    this.week = week;
    // 农历
    this.lYear = lYear;
    this.lMonth = lMonth;
    this.lDay = lDay;
    this.isLeap = isLeap; //是否是闰月
    // 节日记录
    this.lunarFestival = ''; // 农历节日
    this.solarFestival = ''; // 公历节日
    this.solarTerms = ''; // 节气
    // 显示内容
    this.sDisplay = ''; // 公历显示
    this.lDisplay = ''; // 农历显示
    this.lDisplayArr = []; // 农历显示内容
  }
}

// 保存y年m+1月的相关信息
let fat = 9;
let mat = 9;
let eve = 0;
export class SolarTerms {
  length: number;
  firstWeek: number;
  days: any[];
  constructor(y: number, m: number) {
    fat = 0;
    mat = 0;
    let sDObj;
    let lDObj;
    let lY;
    let lM;
    let lD = 1;
    let lL;
    let lX = 0;
    const lDPOS = new Array(3);
    let n = 0;
    // let firstLM = 0;
    sDObj = new Date(y, m, 1); // 当月第一天的日期
    // sDObj = new Date(dayjs().year(y).month(m).date(1).tz('Asia/Shanghai').format())
    this.length = solarDays(y, m); // 公历当月天数
    this.firstWeek = sDObj.getDay(); // 公历当月1日星期几
    this.days = [];
    if (m + 1 === 5) {
      fat = sDObj.getDay();
    }
    if (m + 1 === 6) {
      mat = sDObj.getDay();
    }
    const Today = new Date();
    const tY = Today.getFullYear();
    const tM = Today.getMonth();
    const tD = Today.getDate();
    for (let i = 0; i < this.length; i += 1) {
      if (lD > lX) {
        sDObj = new Date(y, m, i + 1); // 当月第一天的日期
        // sDObj = dayjs().year(y).month(m).date(i + 1).tz('Asia/Shanghai')
        lDObj = new Dianaday(sDObj); // 农历
        lY = lDObj.year; // 农历年
        lM = lDObj.month; // 农历月
        lD = lDObj.day; // 农历日
        lL = lDObj.isLeap; // 农历是否闰月
        lX = lL ? leapDays(lY) : monthDays(lY, lM); // 农历当月最后一天
        if (lM === 12) {
          eve = lX;
        }
        // if (n === 0) firstLM = lM;
        lDPOS[n] = i - lD + 1;
        n += 1;
      }
      this.days[i] = new CalElement(
        y,
        m + 1,
        i + 1,
        nStr1[(i + this.firstWeek) % 7],
        lY || 0,
        lM || 0,
        lD || 0,
        lL || false,
      );
      lD += 1;
    }
    // 节气
    const sT = sTermFix(y, m);
    const solarTerm = getSolarTerm()
    this.days[sT.tmp1].solarTerms = solarTerm[m * 2];
    this.days[sT.tmp2].solarTerms = solarTerm[m * 2 + 1];
    // if ((this.firstWeek + 12) % 7 === 5) {//黑色星期五
    //     this[12].solarFestival += '黑色星期五';
    // }
    if (y === tY && m === tM) {
      this.days[tD - 1].isToday = true; // 今日
    }
  }
}

export default class Lunar {
  lunarCollection: any;
  sFtv: string[];
  lFtv: string[];
  constructor() {
    this.lunarCollection = {};
    this.sFtv = getSFtv();
    this.lFtv = getLFtv();
  }
  set solarFestival(sF) {
    this.sFtv = sF;
  }
  get solarFestival() {
    return this.sFtv;
  }
  set lunarFestival(lF) {
    this.lFtv = lF;
  }
  get lunarFestival() {
    return this.lFtv;
  }
  // 在表格中显示公历和农历的日期,以及相关节日
  generatorCld(SY: number, SM: number) {
    let i;
    let s;
    let sD;
    const cld = new SolarTerms(SY, SM);
    for (i = 0; i < 42; i += 1) {
      let sDisplay = '';
      let lDisplay = '';
      let fullLDisplay = '';
      const lDisplayArr = [];
      sD = i - cld.firstWeek;
      const sDObj = cld.days[sD];
      if (sD > -1 && sD < cld.length) {
        // 日期内
        sDisplay = String(sD + 1);
        lDisplay = cDay(sDObj.lDay); // 显示农历日
        showLunar && lDisplayArr.push(lDisplay);
        if (sDObj.lDay === 1) {
          // 显示农历月
          lDisplay = `${sDObj.isLeap ? '闰' : ''}${nMonth[sDObj.lMonth - 1]}月`;
          showLunar && lDisplayArr.push(lDisplay);
        }
        fullLDisplay = `${sDObj.isLeap ? '闰' : ''}${nMonth[sDObj.lMonth - 1]}月${cDay(sDObj.lDay)}`
        let Slfw = null;
        let Ssfw = null;
        s = sDObj.solarFestival;
        // 公历节日
        for (let ipp = 0; ipp < this.sFtv.length; ipp += 1) {
          if (parseInt(this.sFtv[ipp].substr(0, 2), 10) === SM + 1) {
            if (parseInt(this.sFtv[ipp].substr(2, 4), 10) === sD + 1) {
              lDisplay = this.sFtv[ipp].substr(5);
              Ssfw = this.sFtv[ipp].substr(5);
              lDisplayArr.push(lDisplay);
            }
          }
        }
        if (SM + 1 === 5) {
          // 母亲节
          if (fat === 0) {
            if (sD + 1 === 8) {
              // Ssfw = '母亲节';
              // lDisplay = '母亲节';
              Ssfw = getLabel('91915', '母亲节');
              lDisplay = getLabel('91915', '母亲节');
              lDisplayArr.push(lDisplay);
            }
          } else if (fat < 9) {
            if (sD + 1 === 7 - fat + 8) {
              // Ssfw = '母亲节';
              // lDisplay = '母亲节';
              Ssfw = getLabel('91915', '母亲节');
              lDisplay = getLabel('91915', '母亲节');
              lDisplayArr.push(lDisplay);
            }
          }
        }
        if (SM + 1 === 6) {
          // 父亲节
          if (mat === 0) {
            if (sD + 1 === 14) {
              // Ssfw = '父亲节';
              // lDisplay = '父亲节';
              Ssfw = getLabel('91916', '父亲节');
              lDisplay = getLabel('91916', '父亲节');
              lDisplayArr.push(lDisplay);
            }
          } else if (mat < 9) {
            if (sD + 1 === 7 - mat + 15) {
              // Ssfw = '父亲节';
              // lDisplay = '父亲节';
              Ssfw = getLabel('91916', '父亲节');
              lDisplay = getLabel('91916', '父亲节');
              lDisplayArr.push(lDisplay);
            }
          }
        }
        if (SM + 1 === 11) {
          // 感恩节
          if (sD + 1 === 1 + 21 + ((4 - cld.firstWeek + 7) % 7)) {
            // Ssfw = '感恩节';
            // lDisplay = '感恩节';
            Ssfw = getLabel('91917', '感恩节');
            lDisplay = getLabel('91917', '感恩节');
            lDisplayArr.push(lDisplay);
          }
        }
        // 农历节日
        for (let ipp = 0; ipp < this.lFtv.length; ipp += 1) {
          if (sDObj.lMonth === 12) {
            // 判断是否为除夕
            if (eve === sDObj.lDay) {
              // lDisplay = '除夕';
              // Slfw = '除夕';
              Ssfw = getLabel('91918', '除夕');
              lDisplay = getLabel('91918', '除夕');
              lDisplayArr.push(lDisplay);
            }
          }
          if (parseInt(this.lFtv[ipp].substr(0, 2), 10) === parseInt(sDObj.lMonth, 10)) {
            if (parseInt(this.lFtv[ipp].substr(2, 4), 10) === parseInt(sDObj.lDay, 10)) {
              lDisplay = this.lFtv[ipp].substr(5);
              Slfw = this.lFtv[ipp].substr(5);
              showLunar && lDisplayArr.push(lDisplay);
            }
          }
        }
        // 节气
        if (s.length <= 0) {
          s = sDObj.solarTerms;
          // if (s.length > 0) s = s.fontcolor('limegreen'); // 设置节气的颜色
        }
        if (s.length > 0) {
          lDisplay = s;
          Slfw = s;
          showLunar && lDisplayArr.push(lDisplay);
        }
        if (Slfw !== null && Ssfw !== null) {
          lDisplay = `${Slfw}/${Ssfw}`;
        }
      } else {
        // 非日期
        sDisplay = '';
        lDisplay = '';
      }
      if (sDObj) {
        sDObj.sDisplay = sDisplay;
        sDObj.lDisplay = lDisplay;
        sDObj.lDisplayArr = lDisplayArr;
        //完整农历日期
        if (fullLDisplay) {
          sDObj.fullLDisplay = fullLDisplay
        }
        //新增生肖年
        const remainder = sDObj.lYear % 12
        const animal = animals[remainder]
        if (animal) sDObj.animal = animal

        //新增天干地支年
        //天干
        const y = sDObj.lYear - 3
        const sky_remainder = y % 10
        const sky = zodiac_sky[sky_remainder]
        //地支
        const land_remainder = y % 12
        const land = zodiac_land[land_remainder]
        if (sky && land) {
          sDObj.zodiac = `${sky}${land}`
        }
      }
    }
    return cld;
  }
  // 根据日期获取对应的农历
  getLunarByDate(y: number, m: number, d: number) {
    const yAndM = `${y}-${m}`;
    if (!this.lunarCollection[yAndM]) {
      const cld = this.generatorCld(y, m);
      this.lunarCollection[yAndM] = cld;
    }
    return this.lunarCollection[yAndM].days[d - 1];
  }
}
